import { getPersistentDeviceId } from "@/lib/constants";
import { ROOT_API_ENDPOINTS } from "@/lib/constants/Api";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const authApi = createApi({
  reducerPath: "auth",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const apiKey = `${process.env.NEXT_PUBLIC_X_API_KEY}`;
      const deviceId = getPersistentDeviceId();
      headers.set("x-device-type", `web`);
      headers.set("x-device-id", deviceId);
      headers.set("x-api-key", apiKey);
      headers.set("x-device-name", `${window?.navigator?.userAgent}`);
      headers.set("x-api-key", apiKey);
      return headers;
    },
  }),
  endpoints: (builder) => {
    return {
      generateOtp: builder.mutation({
        query: (body) => {
          return {
            url: ROOT_API_ENDPOINTS.GENERATEOTP,
            method: "POST",
            body,
          };
        },
      }),
      verifyOtp: builder.mutation({
        query: (body) => {
          return {
            url: ROOT_API_ENDPOINTS.VERIFYOTP,
            method: "POST",
            body,
          };
        },
      }),
    };
  },
});

export const { useVerifyOtpMutation, useGenerateOtpMutation } = authApi;
export { authApi };
